export const API_CONSTANTS = {

  Auth: {
    RefreshAccessToken: "Users/RefreshAccessToken",
    Login: "Users/Login",
    getProfileDetails: "Users/GetProfileDetails",
    RequestPasswordReset: "Users/RequestPasswordReset",
    VerifyPasswordResetOTP: "Users/VerifyPasswordResetOTP",
    UpdateUserPassword: "Users/UpdateUserPassword",
    ChangePassword: "UserSettings/UpdatePassword",
    RequestEmailChange: 'Users/RequestEmailChange/',
    VerifyEmailChangeOTP: 'Users/VerifyEmailChangeOTP/',
    ChangeProfileImage: "Users/ChangeProfileImage",
    DeleteUserAccount: "Users/DeleteAccount",
  },

  Registration: {
    CreateRegistrationRequest: "Registration/CreateRegistrationRequest",
    OnboardUser: "Registration/OnboardUser",
    VerifyOTP: "Registration/VerifyOTP",
    LinkedInLogin: "Registration/LinkedInLogin",
    GoogleLogin: "Registration/GoogleLogin",
    ResendOTP: "Registration/ResendOTP/",
  },

  Opportunities: {
    GetOpportunity: "Opportunities/GetOpportunity/",
    GetFullOpportunityDetails: "Opportunities/GetFullOpportunityDetails/",
    GetOpportunityQuestions: "Opportunities/GetOpportunityQuestions/",

    Candidate: {
      GetNewestOpportunities: "Opportunities/GetNewestOpportunities",
      GetEndingSoonOpportunities: "Opportunities/GetEndingSoonOpportunities",
      GetPinnedOpportunities: "Opportunities/GetPinnedOpportunities",
      GetAppliedOpportunities: "Opportunities/GetAppliedOpportunities",
      GetViewedOpportunities: "Opportunities/GetViewedOpportunities",
      GetSimilarOpportunities: "Opportunities/GetSimilarOpportunities/",
      ApplyToOpportunity: "Opportunities/ApplyToOpportunity/",
      SearchOpportunities: "Opportunities/SearchOpportunities/",
      FilterOpportunities: "Opportunities/FilterOpportunities/",
    },

    Provider: {
      CreateOpportunity: "Opportunities/CreateOpportunity",
      RemoveOpportunity: "Opportunities/RemoveOpportunity/",
      UpdateOpportunity: "Opportunities/UpdateOpportunity",
      GetCreatedOpportunities: "Opportunities/GetCreatedOpportunities/",
      GetScheduledOpportunities: "Opportunities/GetScheduledOpportunities/",
      GetDraftedOpportunities: "Opportunities/GetDraftedOpportunities/",
      GetAppliedCandidates: "Opportunities/GetAppliedCandidates/",
      InviteCandidateToOpportunity: "Opportunities/InviteCandidateToOpportunity",
    }
  },

  Bookmarks: {
    SetOpportunityBookmark: "Opportunities/SetOpportunityBookmark/",
    GetBookmarkedOpportunities: "Opportunities/GetBookmarkedOpportunities",
    ClearAllBookmarks: "Opportunities/ClearAllBookmarks",
  },

  Ads: {
    GetAds: "Ads/GetAds",
    SubmitAdRequest: "Ads/SubmitAdRequest",
  },

  Candidate: {
    GetProfileCompletionPercentage: "Candidate/GetProfileCompletionPercentage",
    GetEducations: "Candidate/GetEducations",
    GetExperiences: "Candidate/GetExperiences",
    GetVolunteers: "Candidate/GetVolunteers",
    GetCertifications: "Candidate/GetCertifications",
    GetClubExperience: "Candidate/GetClubExperience",
    GetResume: "Candidate/GetResume",
    GetLanguages: "Candidate/GetLanguages",
    GetProjects: "Candidate/GetProjects",
    GetSkills: "Candidate/GetSkills",
    GetLinks: "Candidate/GetLinks",
    GetInterests: "Candidate/GetInterests",
    GetOtherInfo: "Candidate/GetOtherInfo",
    UpdateResume: "Candidate/UpdateResume",
    UpdateGeneralInfo: "Candidate/UpdateGeneralInfo",
    UpdateProfileInfo: "Candidate/UpdateProfileInfo",
    AddPreferredJobs: "CandidatePreferences/AddPreferredJobs",
    AddPreferredCompanySizes: "CandidatePreferences/AddPreferredCompanySizes",
    AddPreferredRoles: "CandidatePreferences/AddPreferredRoles",
    AddPreferredSalary: "CandidatePreferences/AddPreferredSalary/",
    RemoveEducation: "Candidate/RemoveEducation/",
    RemoveExperience: "Candidate/RemoveExperience/",
    RemoveVolunteer: "Candidate/RemoveVolunteer/",
    RemoveProject: "Candidate/RemoveProject/",
    RemoveCertification: "Candidate/RemoveCertification/",
    ProfileRefresh: {
      Status: "Candidate/ProfileRefresh/Status",
      Start: "Candidate/ProfileRefresh/Start",
      Skip: "Candidate/ProfileRefresh/Skip",
      Step: "Candidate/ProfileRefresh/Step",
      Complete: "Candidate/ProfileRefresh/Complete",
    },
  },

  CandidateCompletion: {
    AddResumeDetails: "CandidateCompletion/AddResumeDetails",
    AddLinkDetails: "CandidateCompletion/AddLinkDetails",
    AddEducation: "CandidateCompletion/AddEducation",
    AddExperience: "CandidateCompletion/AddExperience",
    AddVolunteer: "CandidateCompletion/AddVolunteer",
    AddProject: "CandidateCompletion/AddProject",
    AddCertification: "CandidateCompletion/AddCertification",
    AddLanguages: "CandidateCompletion/AddLanguages",
    AddOtherInfo: "CandidateCompletion/AddOtherInfo",
    AddSkills: "CandidateCompletion/AddSkills",
    AddInterests: "CandidateCompletion/AddInterests",
    AddClubExperience: "CandidateCompletion/AddClubExperience",
    GetCompletionProgress: "CandidateCompletion/GetCompletionProgress",
    SetNoWorkExperience: "CandidateCompletion/SetNoWorkExperience",

    EditEducation: "CandidateCompletion/EditEducation",
    EditExperience: "CandidateCompletion/EditExperience",
    EditVolunteer: "CandidateCompletion/EditVolunteer",
    EditProject: "CandidateCompletion/EditProject",
    EditCertification: "CandidateCompletion/EditCertification",
    EditLanguages_Links: "CandidateCompletion/EditLanguages_Links",
  },

  ContactRequest: {
    CreateContactRequest: "ContactRequest/CreateContactRequest",
  },

  CompanyInterest: {
    CreateCompanyInterest: "CompanyInterest/CreateCompanyInterest",
  },

  Provider: {
    GetCandidates: "Provider/GetCandidates/",
    GetCandidateDetails: "Provider/GetCandidateDetails/",
    GetPopularCandidates: "Provider/GetPopularCandidates",
    FilterCandidates: "Provider/FilterCandidates",
    UpdateProfileInfo: "Provider/UpdateProfileInfo",
  },

  Subscription: {
    PublishedCandidatePlans: "subscription-plans/candidate/published",
    PublishedProviderPlans: "subscription-plans/provider/published",
    MyCandidateSubscription: "subscriptions/me/candidate",
    MyProviderSubscription: "subscriptions/me/provider",
    CheckoutCandidate: "subscriptions/checkout/candidate",
    CheckoutProvider: "subscriptions/checkout/provider",
    CancelMyCandidateSubscription: "subscriptions/me/candidate/cancel",
    CancelMyProviderSubscription: "subscriptions/me/provider/cancel",
  },

  AppConfig: {
    GetPublic: "app-config",
  },

  Packages: {
    GetPackagePrices: "Packages/GetPackagePrices/",
    CheckoutPackage: "Packages/CheckoutPackage/",
    CheckoutPackagePost: "Packages/CheckoutPackage",
    PreviewCheckout: "Packages/PreviewCheckout/",
    GetPackage: "Packages/GetPackage/",
    GetActivePackage: "Packages/GetActivePackage/",
    RequestCVPackage: "Packages/RequestCVPackage/",
    RequestLinkedInPackage: "Packages/RequestLinkedInPackage/",
    UploadMockInterviewResume: "Packages/UploadMockInterviewResume/",
    MyProcessOrder: "Packages/MyProcessOrder",
    UploadProcessResume: "Packages/UploadProcessResume",
    SubmitProcess: "Packages/SubmitProcess",
  },

  Notifications: {
    getUnreadNotificationsCount: 'Notifications/GetUnreadNotificationsCount',
    GetNotifications: 'Notifications/GetNotifications',
    ReadNotifications: 'Notifications/ReadNotifications',
  },

  Analytics: {
    RecordOpportunityView: 'Analytics/RecordOpportunityView/',
    RecordOpportunityClick: 'Analytics/RecordOpportunityClick/',
    RecordLastVisit: 'Analytics/RecordLastVisit',
  },

}
